<template>
  <v-layout>
    <v-tabs vertical class="my-tabs" v-model="active_tab">
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ២.ក
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table</v-icon>តារាង​ ២.ខ
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table</v-icon>តារាង​ ២.គ​ ២.ឃ ២.ង
      </v-tab>
      <v-tab-item>
        <prestueth
          :data="stu_pre"
          :title="title[1] + ' ' + cur_acc"
          ctitle="អាយុ<p>(ឆ្នាំ)</p>"
          :age_cont="age_cont"
        />
      </v-tab-item>
      <v-tab-item>
        <predisable :data="dis_pre" :title="title[2]" :htext="pp[3]"/>
      </v-tab-item>
      <v-tab-item>
        <div>
          <prestueth
            :data="eth_pre"
            :title="title[3]"
            ctitle="ជនជាតិដើមភាគ<p>តិចតាមក្រុមអាយុ</p>"
            :age_cont="age_cont"
          />
          <preMigration :data="pre_esms" :title="title[4]" ctitle="(ចំនួនកុមារភៀសសឹក)" :curacc="cur_acc"/>
          <prelaststu :data="lst_pre" :title="title[5]" :lastAcc="lst_acc" />          
        </div>
      </v-tab-item>
    </v-tabs>
  </v-layout>
</template>

<script>
import preStudentEth from "@/components/ascf/pre/preEthnic.vue";
import preMigration from "@/components/ascf/pre/preMigration.vue";
import preLastStu from "@/components/ascf/pre/preLastStudent.vue";
import preDisable from "@/components/ascf/pre/preDisable.vue";
import { pp } from "@/utils/zdesc/ppre.js"

export default {
  props: [
    "title",
    "age_cont",
    "stu_pre",
    "dis_pre",
    "eth_pre",
    "pre_esms",
    "lst_pre",    
    "lst_acc",
    "cur_acc",
  ],
  components: {
    /** Student and Ethnic student are the same Form */
    predisable: preDisable,
    prestueth: preStudentEth,
    preMigration: preMigration,
    prelaststu: preLastStu,
  },
  data() {
    return {
      active_tab: 0,
      pp: pp
    };
  },
  methods: {},
};
</script>
<style scoped>
.row {
  display: flex;
}
.ttext {
  font-family: "Siemreap";
  font-size: 12px;
  font-weight: bold;
}
div.my-tabs [role="tab"] {
  justify-content: flex-start;
}
</style>